import { SizeLimits } from './types';

export const MAX_COMPRESSION_RATIO = 30;

export const ZIP_LIMITS: SizeLimits = { min: 22, max: 2048 * 1024 * 1024 };
export const PDF_LIMITS: SizeLimits = { min: 1024, max: 2048 * 1024 * 1024 };
export const PPT_LIMITS: SizeLimits = { min: 1536, max: 2048 * 1024 * 1024 };
export const IMAGE_LIMITS: SizeLimits = { min: 10, max: 200 * 1024 * 1024 };

// Polyglot detection: scan first N bytes (balance security vs memory)
export const POLYGLOT_SCAN_SIZE = 1 * 1024 * 1024; // 1MB

export const DANGEROUS_EXTENSIONS = [
  'exe',
  'msi',
  'scr',
  'com',
  'pif', // Applications/Installers
  'bat',
  'cmd',
  'vbs',
  'vbe',
  'ps1',
  'js',
  'hta',
  'cpl', // Scripts/Commands
  'lnk',
  'url', // Shortcuts
  'inf',
  'reg', // Configuration/System
] as const;
